var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('v-img',{attrs:{"src":_vm.image,"width":"100%"}}):_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({},'v-icon',attrs,false),on),[_vm._v(" mdi-image-broken-variant ")])]}}])},[_c('span',[_vm._v("Client did not upload an image with "+_vm._s(_vm.firstLastAssessment)+" completed assessment")])])}
var staticRenderFns = []

export { render, staticRenderFns }